<h1 class="abilHeader">
  {{ header() || "" | translate }}
</h1>
@if (bold1()){
<div class="list">
  <span class="rectangle"></span>
  <p class="abilText">
    <span class="abilBold">{{ bold1() || "" | translate }}</span>
    {{ text1() || "" | translate }}
  </p>
</div>
}
@if (bold2()){
<div class="list">
  <span class="rectangle"></span>
  <p class="abilText">
    <span class="abilBold">{{ bold2() || "" | translate }}</span>
    {{ text2() || "" | translate }}
  </p>
</div>
}
@if (bold3()){
<div class="list">
  <span class="rectangle"></span>
  <p class="abilText">
    <span class="abilBold">{{ bold3() || "" | translate }}</span>
    {{ text3() || "" | translate }}
  </p>
</div>
}
@if (bold4()){
<div class="list">
  <span class="rectangle"></span>
  <p class="abilText">
    <span class="abilBold">{{ bold4() || "" | translate }}</span>
    {{ text4() || "" | translate }}
  </p>
</div>
}
